import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CookiesModalComponent } from 'src/app/shared/cookies-modal/cookies-modal.component';
import { ModalConfig } from "src/app/shared/cookies-modal/cookies-modal.config";
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-footer-main',
  templateUrl: './footer-main.component.html',
  styleUrls: ['./footer-main.component.css']
})
export class FooterMainComponent implements OnInit {

  @ViewChild('modal') private modal?: CookiesModalComponent
  @Input() isInmuebles: boolean = false

  cookieValue: string = "";
  cookieBottomMsgVisible: boolean = true;

  constructor(private cookieService: CookieService,
    private window: Window, private document: Document) { }

  public modalConfig: ModalConfig = {
    modalTitle: "Title",
    onDismiss: () => {
      return true
    },
    dismissButtonLabel: "Dismiss",
    onClose: () => {
      return true
    },
    closeButtonLabel: "Close"
  }

  async openModal() {
    return await this.modal?.open()
  }

  AcceptAllCookies() {
    this.cookieService.set('isCookieSubmitted', 'YES', new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 365)));
    this.cookieBottomMsgVisible = false;

    this.cookieService.set('tmCookie', 'YES', new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 365)));

    window.location.reload()

  }
  RejectAllCookies() {
    this.cookieService.set('isCookieSubmitted', 'YES', new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 365)));
    this.cookieBottomMsgVisible = false;

    this.cookieService.delete('tmCookie');

    window.location.reload()

  }


  ngOnInit(): void {

    this.cookieValue = this.cookieService.get('isCookieSubmitted');

    if (this.cookieValue) {
      // this.cookieService.set('isCookieSubmitted', 'GDPR', new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 365 * 10)));
      this.cookieBottomMsgVisible = false;
    }


  }

}
